export const stripHTML = (input: string) => {
  const withoutTags = input.replace(/<\/?[^>]+(>|$)/g, ""); // Remove HTML tags
  const withoutEntities = withoutTags.replace(/&\w+;/g, ""); // Remove HTML entities
  return withoutEntities;
};